import config from './../package.json'
import TicTest from './components/Test'
import TicTree from './components/tree/Tree'
import TicCascader from './components/cascader/Cascader'
import TicEnquiryDetail from './components/enquiry/Detail'
import TicLoginMerge from './components/loginMerge/index'
import CertificateForm from './components/certificate/CertificateForm'
import TicCertificateCard from './components/certificate/CertificateCard'
import TicAbroadCertificateCard from './components/certificate/AbroadCertificateCard'
import WashingMarkForm from './components/certificate/WashingMarkForm'
import WashingMarkForm1 from './components/certificate/WashingMarkForm1'
import WashingMarkForm2 from './components/certificate/WashingMarkForm2'
import Sample from './components/sample/Sample';
import TicDownloadPdf from './components/downloadPdf/TicDownloadPdf';
import TicNameQuery from './components/nameQuery/index'
import TicChatPdf from './components/downloadPdf/TicChatPdf'
import TicAlipayPdf from './components/downloadPdf/TicAlipayPdf'
import PortalTopbar from './components/portal/Topbar'
import PortalNavigation from './components/portal/Navigation'
import PortalFooter from './components/portal/Footer'
import PortalCopyright from './components/portal/Copyright'
import PortalQuestion from './components/portal/Question'
import PortalInformation from './components/portal/Information'
import PortalCaseCard from './components/portal/CaseCard'
import PortalCaseCardForHome from './components/portal/CaseCardForHome'
import PortalCaseDetail from './components/portal/CaseDetail'
import StoreOrderOnline from './components/store/OrderOnline'
import TicApply from './components/apply/index.vue'
import TicInvoice from './components/invoice/index.vue'
import TicUpload from './components/UploadFile/index.vue'
import TicLoginVerifyCode from "./components/loginVerifyCode/index.vue";
import TicFixedMenus from './components/fixedMenus/index.vue'
import PortalQuote from './components/portal/quote.vue'
import TicAddBuyer from './components/addBuyer/index.vue'
import TicAddress from './components/apply/ChooseAddress.vue'
import TicApplication from './components/application/index.vue'


const components = [
  TicTest,
  TicTree,
  TicCascader,
  TicEnquiryDetail,
  TicLoginMerge,
  CertificateForm,
  TicCertificateCard,
  TicAbroadCertificateCard,
  WashingMarkForm,
  WashingMarkForm1,
  WashingMarkForm2,
  Sample,
  TicDownloadPdf,
  TicNameQuery,
  TicChatPdf,
  TicAlipayPdf,
  PortalTopbar,
  PortalNavigation,
  PortalFooter,
  PortalCopyright,
  PortalQuestion,
  PortalInformation,
  PortalCaseCard,
  PortalCaseCardForHome,
  PortalCaseDetail,
  StoreOrderOnline,
  TicApply,
  TicInvoice,
  TicUpload,
  TicLoginVerifyCode,
  TicFixedMenus,
  PortalQuote,
  TicAddBuyer,
  TicAddress,
  TicApplication
]

const install = Vue => {
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: config.version,
  install,
}
